<template>
  <div class="page-wrapper py-4">
    <div  id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <MasClientesNew id="page1" bg="white" class="section" />
      <InvitacionesPersonalizadasNew id="page2" bg="black" class="section" />
      <ListaEsperaNew id="page3" bg="white" class="section" />
      <RemarketingNew id="page4" bg="white" class="section" />
      <BeneficiosClaveVideoNew id="page5" bg="black" class="section" />
      <TituloMarketingNew id="page6" bg="black" class="section" />
      <ReservacionesNew id="page7" bg="white" class="section" />
      <TestimonioSushiRollNew id="page8" bg="white" class="section" />
      <CallToActionNew id="page9" bg="white" class="section" />
      <FooterNew id="page10" bg="black" class="section" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import MasClientesNew from '@/components/pages/flow/MasClientesNew.vue'
import InvitacionesPersonalizadasNew from '@/components/pages/flow/InvitacionesPersonalizadasNew.vue'
import ListaEsperaNew from '@/components/pages/flow/ListaEsperaNew.vue'
import ReservacionesNew from '@/components/pages/flow/ReservacionesNew.vue'
import RemarketingNew from '@/components/pages/flow/RemarketingNew.vue'
import BeneficiosClaveVideoNew from '@/components/pages/flow/BeneficiosClaveVideoNew.vue'
import TituloMarketingNew from '@/components/pages/flow/TituloMarketingNew.vue'
import TestimonioSushiRollNew from '@/components/pages/flow/TestimonioSushiRollNew.vue'
import CallToActionNew from '@/components/pages/flow/CallToActionNew.vue'
import FooterNew from '@/components/pages/flow/FooterNew.vue'

export default {
  name: 'FlowView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    MasClientesNew,
    InvitacionesPersonalizadasNew,
    ListaEsperaNew,
    ReservacionesNew,
    RemarketingNew,
    BeneficiosClaveVideoNew,
    TituloMarketingNew,
    TestimonioSushiRollNew,
    CallToActionNew,
    FooterNew
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
    }
  },
  mounted(){
    if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 10) {
        this.currentSection = 10;
      } else {
        this.currentSection = section;
      }
    },
 
  },
}
</script>

<style lang="css">
/* 1) El wrapper ocupa toda la pantalla */
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}


@media (max-width: 992px) {
  .master {
      padding-top: 0px !important;
  }
}
</style>